import CreateEdgeConfigForm from "./CreateEdgeConfigForm";

const CreateV3EdgeConfig = () => {
    return <CreateEdgeConfigForm deviceType="V3" />;
};

export default CreateV3EdgeConfig;
